import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs';

import { CustomizationStore, CustomizationState } from './customization.store';
import { Customization } from '@models/profileConfiguration/model';

@Injectable({
  providedIn: 'root',
})
export class CustomizationQuery extends QueryEntity<CustomizationState> {
  protected store: CustomizationStore;

  constructor() {
    const store = inject(CustomizationStore);

    super(store);

    this.store = store;
  }

  public selectActiveWhenLoaded(): Observable<Customization | undefined> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectActive())
    );
  }
}
